import React from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { theme } from '../../styles';
import { Clinic, Tenancy, SelectedTenancyCount } from '../../types';

interface TenanciesSectionProps {
  isFetchingData: boolean;
  clinicsState: Clinic[];
  selectedTenancyCount: SelectedTenancyCount;
  handleChange: (e: React.ChangeEvent<any>, tenancyId: string) => void;
}

const TenanciesSection: React.FC<TenanciesSectionProps> = ({
  clinicsState,
  selectedTenancyCount,
  handleChange,
  isFetchingData,
}) => {
  // Pure function to extract tenancies from clinic data (no side effects)
  const getTenanciesData = React.useMemo(() => {
    if (clinicsState.length === 0) {
      return [];
    }

    const map: Tenancy[] = [];
    for (let i = 0; i < clinicsState.length; i++) {
      if (
        map.findIndex((x) => x.tenancy_id === clinicsState[i].tenancy_id) === -1
      ) {
        map.push({
          tenancy_id: clinicsState[i].tenancy_id,
          tenancy_name:
            clinicsState[i].tenancy_name ||
            `Tenancy ${clinicsState[i].tenancy_id}`,
        });
      }
    }
    return map;
  }, [clinicsState]);

  // Render tenancies with accordion UI (only one can be open at a time)
  const renderTenancies = React.useMemo(() => {
    return (
      <Accordion defaultActiveKey="0" flush>
        {getTenanciesData.map((t, index) => (
          <Accordion.Item eventKey={index.toString()} key={t.tenancy_id}>
            <Accordion.Header
              className={{ fontFamily: 'Roboto Condensed' } as any}
            >
              <div style={{ margin: '10px' }}>{t.tenancy_name} </div>
              {selectedTenancyCount[t.tenancy_id]} selected
            </Accordion.Header>
            <Accordion.Body>
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                  gap: '10px',
                  padding: '10px 0',
                }}
              >
                {clinicsState
                  .filter((clinic) => clinic.tenancy_id === t.tenancy_id)
                  .map((clinic, clinicIndex) => (
                    <label
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        cursor: 'pointer',
                        // padding: '8px',
                      }}
                      key={`clinic-${clinic.id}`}
                      htmlFor={clinic.tenancy_id + '-' + clinic.id + '-input'}
                    >
                      <input
                        type="checkbox"
                        id={clinic.tenancy_id + '-' + clinic.id + '-input'}
                        onChange={(e) => handleChange(e, t.tenancy_id)}
                        style={{
                          accentColor: theme.colors.primary,
                          marginRight: '8px',
                        }}
                      />
                      <span
                        style={{
                          fontSize: '14px',
                          lineHeight: '1.2',
                          wordBreak: 'break-word',
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          const checkbox = document.getElementById(
                            clinic.tenancy_id + '-' + clinic.id + '-input',
                          ) as HTMLInputElement;
                          if (checkbox) {
                            checkbox.click();
                          }
                        }}
                      >
                        {clinic.clinic_name}
                      </span>
                    </label>
                  ))}
              </div>
            </Accordion.Body>
          </Accordion.Item>
        ))}
      </Accordion>
    );
  }, [getTenanciesData, clinicsState, selectedTenancyCount, handleChange]);

  return (
    <>
      <div
        style={{
          display: 'flex',
          margin: '10px',
          color: '#bebebe',
          fontSize: '14px',
          cursor: 'default',
        }}
      >
        <b>Clinics</b>
      </div>
      {isFetchingData && <div>Loading clinics ...</div>}
      {clinicsState.length !== 0 && !isFetchingData && (
        <div
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '8px',
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
          }}
        >
          {renderTenancies}
        </div>
      )}
    </>
  );
};

export default TenanciesSection;
